import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationSuccess } from './interfaces';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { cost, recipientMsisdn, operator, details } = operation;
  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            {
              label: locales.operation.label.recipient,
              value: detailsValueFormatter(recipientMsisdn)
            },
            { label: locales.operation.label.operatorName, value: operator },
            { label: locales.operation.label.smsSenderName, value: detailsValueFormatter(details.senderName) },
            {
              label: locales.operation.label.smsExternalProvider,
              value: detailsValueFormatter(details.externalProvider)
            },
            { label: locales.operation.label.smsExternalId, value: detailsValueFormatter(details.externalId) },
            { label: locales.operation.label.smsMessageContent, value: detailsValueFormatter(details.messageContent) }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
